import { render, staticRenderFns } from "./CalendarWeekSelector.vue?vue&type=template&id=b57f148a&"
import script from "./CalendarWeekSelector.vue?vue&type=script&lang=js&"
export * from "./CalendarWeekSelector.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWeekSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports